type PushErrorCode =
  | "user-denied"
  | "subscribe-failed-browser"
  | "subscribe-failed-database";

export class PushError extends Error {
  constructor(
    readonly code: PushErrorCode,
    readonly employeeId: string,
  ) {
    super(code);
  }
}
